// extracted by mini-css-extract-plugin
module.exports = {"section":"ContentListing_section__1z33m","heading":"ContentListing_heading__3Re27","slider":"ContentListing_slider__3xw36","arrow":"ContentListing_arrow__gJAV7"};